export default __webpack_public_path__ + "9ae845706ea2d0f48f2c6fad6c1afc73.png";